import api from 'config/Api/Api';

const baseEndpoint = 'v1/user';

export default {

  getUser() {
    return api.get( baseEndpoint );
  },

  updateUser( data ) {
    return api.post( baseEndpoint, data );
  },

  changePassword( data ) {
    return api.post( `${baseEndpoint}/change-password`, data );
  },

  recoverPassword( data ) {
    return api.post( `${baseEndpoint}/recover-password`, data );
  },

  resetPassword( token, data ) {
    return api.post( `${baseEndpoint}/recover-password/${token}`, data );
  },

  getCurrency() {
    return api.get( `v1/get-currency` );
  },
  
  getStatus() {
    return api.get( `v1/check-user-account` );
  },
  getSignUpPromo(){
    return api.get( `v1/get-signup-promo` );
  }
};
